import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { useParams, useHistory } from "react-router-dom";

import { LoaderDots } from "../../../middleware/loaders";
import { IconJumbotron } from "../../common/icons";
import { GET_RESPONSE } from "./queries";
import { ReaderItem } from "../../../models/reader";
import { DB_response } from "./models";
import { StudentItem } from "../../../models/student";
import { useRef } from "react";
import Reviews from "./student_reviews";
import BookInfo from "./bookInfo";

const AuthorBook: React.FC = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const video_ref = useRef<HTMLVideoElement>(null);
  const { reader_id } = useParams<{ reader_id: string }>();
  const [reader, setReader] = useState<ReaderItem | false>(false);
  const [students, setStudents] = useState<StudentItem[]>([]);
  const [video, setVideo] = useState({ play: false });
  const { data: db_readers, loading: loading_reader } = useQuery<DB_response>(
    GET_RESPONSE,
    {
      variables: { book_id: reader_id },
      fetchPolicy: "no-cache",
    }
  );

  const history = useHistory();
  useEffect(() => {
    const book_info = document.getElementById("book_info");
    if (book_info) {
      book_info.scrollIntoView({ block: "start" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reader_id]);

  useEffect(() => {
    if (db_readers) {
      if (db_readers.book) {
        setReader(db_readers.book);
      }
      if (db_readers.students) {
        setStudents(db_readers.students);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [db_readers]);

  const handlePlayVideo = () => {
    const set_video = { ...video };
    set_video.play = !set_video.play;
    if (set_video.play && video_ref.current) {
      video_ref.current.play();
    }
    setVideo(set_video);
  };

  const goBack = () => {
    try {
      history.goBack();
    } catch (_) {
      history.push("/");
    }
  };

  if (!reader) {
    return (
      <main className="first-container no_padding bookdetails_page py-5">
        {loading_reader ? (
          <LoaderDots />
        ) : (
          <IconJumbotron
            classes="my-5"
            txt_classes="text-white"
            icon="fas fa-books"
            txt="Book does not exist"
            cta={{
              link: "/",
              txt: "Go to Home",
              classes: "btn btn-light ",
            }}
          />
        )}
      </main>
    );
  }

  return (
    <main className="first-container no_padding bookdetails_page">
      <div className="book_details">
        <BookInfo
          reader={reader}
          goBack={goBack}
          user={user}
          playVideo={handlePlayVideo}
        />
        {reader.video_url ? (
          <div className={`video_container ${video.play ? "active" : ""}`}>
            <video
              controls={true}
              onPause={handlePlayVideo}
              ref={video_ref}
              controlsList="nodownload"
            >
              <source src={reader.video_url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ) : null}
      </div>
      {user.is_teacher ? (
        <Reviews book_id={reader.id} students={students} />
      ) : null}
    </main>
  );
};

export default AuthorBook;
